export default __webpack_public_path__ + "static/media/grc_banner.c5ff7eac.png";